// extracted by mini-css-extract-plugin
export default {"root":"oVmXv8OrB2"};